export default __webpack_public_path__ + "static/media/avatar_2@2x.a69386c5.png";